import { useTranslate } from 'hooks/useTranslate';

import { Board, User } from 'types';

type BoardMemberBadgeProps = {
  board: Board;
  user: User;
  memberId: string;
};

const BoardMemberBadge = ({ board, user, memberId }: BoardMemberBadgeProps) => {
  const { t } = useTranslate();

  const isParticipant =
    board.participants?.some(
      (participant) => participant.member === memberId
    ) ?? false;

  const userPartnerRepresentants = user?.partnerRepresentants ?? [];

  const isRepresentant =
    board?.delegationRepresentants?.some((representant) =>
      userPartnerRepresentants.includes(representant)
    ) ?? false;

  const getBadgeLabel = () => {
    if (isParticipant) return t('BoardMemberParticipant');
    if (isRepresentant) return t('BoardMemberRepresentant');
    return '';
  };

  const badgeLabel = getBadgeLabel();
  const badgeClassName = `badge badge-pill badge-success`;

  return badgeLabel ? (
    <span className={badgeClassName}>{badgeLabel}</span>
  ) : null;
};

export default BoardMemberBadge;
